import animation from '@helpers/animation';
import { imageUrl } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import React from 'react';
import S from './RichText.styles';
const RichText = ({ align, animAlign = 'left', bgColor, content, cta, fadeInContent = true, image, leadParagraph = false, longCta, pageContext, width = 'narrow', }) => {
    const [refContainer, isInView] = useInView({
        rootMargin: animation.inView.rootMargin,
    }, false, pageContext?.isEditMode);
    return (React.createElement(S.Container, { ref: refContainer, "data-bg-color": bgColor, "data-anim-align": animAlign, "data-has-anim": image ? true : false, innerWidth: width, isActive: fadeInContent ? isInView : true, "data-long-cta": longCta, flush: 'both' },
        React.createElement(S.ContentBlock, { align: align },
            React.createElement(S.Content, { align: align, dangerouslySetInnerHTML: { __html: content }, leadParagraph: leadParagraph }),
            cta?.text && (React.createElement(S.Base, { align: align },
                React.createElement(LinkButton, { branding: cta?.branding ?? 'primary', href: cta?.url, target: cta?.target, title: cta?.text }))),
            image && (React.createElement(S.ImageSection, null,
                React.createElement(S.Image, { alt: '', loading: "lazy", role: "presentation", src: imageUrl(image, { crop: 'lfill' }) }))))));
};
export default RichText;
